const HospitalBranding = ({ hospitalName, hospitalLogo, hospitalImage }) => {
    if (hospitalName || hospitalImage) {
        return (
            <div className="d-flex flex-column align-items-center mb-2 mt-3">
                {hospitalLogo && hospitalImage && (
                    <img src={hospitalImage} alt="" style={{ maxHeight: '100px', maxWidth: '100px' }} />
                )}
                {hospitalName && (
                    <span className="app-brand-text fw-bolder text-center" style={{ fontSize: '20px', color: '#041F60' }}>
                        {hospitalName}
                    </span>
                )}
            </div>
        );
    }

    return (
        <div className="d-flex flex-column align-items-center mb-2 mt-5">
            <img src="/applogo.png" alt="OHOINDIA logo" style={{ maxHeight: '60px', maxWidth: '60px' }} />
            <span className="app-brand-text fw-bolder" style={{ fontSize: '25px', color: '#041F60' }}>
                OHOINDIA
            </span>
        </div>
    );
};

export default HospitalBranding;
